import 'eonasdan-bootstrap-datetimepicker/src/js/bootstrap-datetimepicker.js';
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';
import 'moment/locale/fr';

import { displayMapInputValue } from './map.js';
import { activateMapHelper, activateMarkdownHelper } from 'table/helper';
import dialog from 'tools/dialog';

export function initializeFormFields(container = '') {
  // Read Only Fields
  displayReadonlyFields(container);

  // Date & Time Pickers
  datepicker(container);
  timepicker(container);

  // Map
  displayMapInputValue(container);

  // Labels - Translation
  displayFlags(container);

  // Entity Links
  activateEntityLinks(container);

  // File Fields
  cleanFileFields(container);

  // Helpers
  activateMapHelper(container);
  activateMarkdownHelper(container);
  activateWidgetHelper(container);
}

function displayReadonlyFields(container = '') {
  const fields = ['select[readonly]', 'input[type="number"][readonly]'];
  const fieldsSelector = fields.map((s) => container + ' ' + s).join(',');

  $(fieldsSelector).each(function () {
    if (!$(this).data('readonly-done')) {
      $(this).addClass('hidden').attr('readonly', false);

      let id = $(this).attr('id');
      let value = $(this).val();
      let label;

      if (value) {
        if ($(this).is('select')) {
          if (typeof value === 'object') {
            label = [];
            let select = $(this);
            $.each(value, function (key, val) {
              label.push(select.children('option[value=' + val + ']').text());
            });
            label = label.join(', ');
          } else {
            label = $(this)
              .children('option[value=' + value + ']')
              .text();
          }
        } else {
          label = value;
        }
      }

      let readOnlyField = $(
        '<input id="' +
          id +
          '_label" readonly="readonly" class="form-control" type="text">'
      );
      readOnlyField.val(label);
      $(this).after(readOnlyField);

      $(this).data('readonly-done', true);
    }
  });

  $(container + ' input[type="checkbox"][readonly]').each(function () {
    if (!$(this).data('readonly-done')) {
      $(this).attr('readonly', false);
      let readOnlyField = $(this).clone();
      $(this).addClass('hidden');

      readOnlyField
        .prop('disabled', true)
        .attr('id', readOnlyField.attr('id') + '_readOnly');
      $(this).after(readOnlyField);

      $(this).data('readonly-done', true);
    }
  });
}

// Date & Time Pickers
function datepicker(container = '') {
  $(container + ' input[type=datepicker]')
    .parent()
    .datetimepicker({
      locale: $('html').attr('lang'),
      format: 'DD/MM/YYYY',
      widgetPositioning: { horizontal: 'left' },
    });
}

function timepicker(container = '') {
  $(container + ' input[type=timepicker]')
    .parent()
    .datetimepicker({
      locale: $('html').attr('lang'),
      format: 'HH:mm',
      widgetPositioning: { horizontal: 'left' },
    });
}

// Translation
function displayFlags(container = '') {
  $(container + ' .tp-table-translatable').each(function () {
    if ($(this).children('i').length === 0) {
      let flagClass = $(this).data('flag');
      let flag = $('<i>').addClass(flagClass);
      $(this).append(flag);
    }
  });
}

// Entity Links
function activateEntityLinks(container = '') {
  $(container + ' .tp-table-entity-link i').click(function () {
    window.open($(this).data('link'));
  });
}

// File Links
function cleanFileFields(container = '') {
  $(container + ' .tp-table-file-widget input').each(function () {
    if ($(this).val() === '') {
      $(this).siblings('span').addClass('hidden');
    }
  });
  $(container + ' .tp-table-file-widget input').on('change', function () {
    if ($(this).val() === '') {
      $(this).siblings('span').addClass('hidden');
    } else {
      $(this).siblings('span').removeClass('hidden');
    }
  });
  $(container + ' .tp-table-file-widget span').on('click', function () {
    $('#' + $(this).data('input-id')).val('');
    $(this).addClass('hidden');
  });
}

// Widget Helper
function activateWidgetHelper(container = '') {
  $(container + ' .tp-table-widget-with-help span').click(function () {
    const dialogLabel = $(this).attr('title');
    const dialogContent = $(this).attr('data-help-content');
    dialog.open(dialogLabel, dialogContent, 1200, true);
  });
}
